import React, { useEffect, useRef, useState, useContext } from "react";
import "./Crafted.css";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Crafted = () => {
  const wrapperRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const { currentLang } = useContext(LanguageContext);

  const [crafted, setCrafted] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  // Fetch section data
  useEffect(() => {
    const fetchCrafted = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/CraftedSection?lang=${currentLang}`
        );
        setCrafted(res.data);
      } catch (err) {
        console.error("Error fetching Crafted Section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCrafted();
  }, [currentLang]);

  // Progress scroll animation
  useEffect(() => {
    const onScroll = () => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;

      const start = wrapper.offsetTop;
      const end = start + wrapper.offsetHeight - window.innerHeight;
      const scrollY = window.scrollY;

      const ratio = Math.min(Math.max((scrollY - start) / (end - start), 0), 1);
      setProgress(ratio);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  if (loading) return <div className="crafted-loading">Loading...</div>;
  if (!crafted) return <div className="crafted-error">No crafted data found.</div>;

  // Background/text color shift
  const bgVal = Math.round(progress * 255);
  const bgColor = `rgb(${bgVal}, ${bgVal}, ${bgVal})`;
  const textColor = `rgb(${255 - bgVal}, ${255 - bgVal}, ${255 - bgVal})`;

  // Fade between text1 and text2
  const midPoint = 0.25;
  const isSecond = progress > midPoint;
  const fade = isSecond
    ? (progress - midPoint) / (1 - midPoint)
    : 1 - progress / midPoint;

  // Image with timestamp (forces update)
  const imageUrlWithTimestamp = crafted.imageUrl
    ? `${resolveUrl(crafted.imageUrl)}?t=${new Date().getTime()}`
    : "none";

  const styleImageCR = {
    backgroundImage: `url(${imageUrlWithTimestamp})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "100%",
    height: "100vh",
    aspectRatio: "16 / 9",
  };

  return (
    <>
      <div
        className="crafted-wrapper"
        ref={wrapperRef}
        style={{ height: "300vh" }}
      >
        <section
          className="crafted-sticky"
          style={{
            backgroundColor: bgColor,
            color: textColor,
          }}
        >
          <div className="crafted-inner">
            <p
              className="crafted-text"
              style={{
                opacity: isSecond ? fade : 1 - fade,
                transition: "opacity 0.3s ease-out",
              }}
            >
              {isSecond ? crafted.text2 : crafted.text1}
            </p>
          </div>
        </section>
      </div>

      <div className="imageCR" style={styleImageCR}></div>
    </>
  );
};

export default Crafted;
